export const hash = 'a87b736d-128f-4957-ae8e-1348db8c796c';

// export const gateKey = '';
export const gateKey = 'ek_live_g5Df6bp6y5ptAKeOVOpBloZHmqY0sb';
export const recaptchaKey = '6Ld9r7cZAAAAABw5wijiLD5PhlWqLivIN9NqFKi_';
export const apiUrl = `https://api-global-v3.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://socket-2023.encontrodigital.com.br';



//export const apiSocket = 'http://localhost:8080';

//export const apiUrl = `http://localhost:8000/${hash}`;
export const websitePath = 'https://ingressos.legadocoop.com.br';
export const urlWebsite = 'https://ingressos.legadocoop.com.br';
export const supportNumber = `5551995181533`;
export const home = 'Home';
export const haveTranslate = false;
export const defaultProjectHash = 'evento';
// export const urlWebsite = 'http://localhost:3000';
export const eventName = 'Legado Coop';
export const logo = '/assets/logo2.png';
export const background = '/assets/Fundo.jpg';
export const authTitle = 'Legado Coop';
export const dadosOrganizacao = '';
export const social = {
    whatsapp: '',
    instagram: '',
    facebook: '',
    linkedin: '',
    youtube: '',
    spotify: '',
    twitter: '',
};


export const defaultTheme = {
    defaultBackground: '#191a3df2',
    defaultColor: '#fff',
    logo: {
        minWidth: '450px',
    },
    menu: {
        background: '#191a3df2',
        backgroundSticky: '#191a3df2',
        backgroundMobile: '#fff',
        color: '#fff',
        shadow: '0',
        logoColor: 'none',
    },
};

export const getToken = (): string | null => {
    const token = localStorage.getItem(`@${authTitle}:token`);
    return token;
};
